import React, { useEffect, useRef } from "react";
import { startLoading, stopLoading } from "../loadingManager";
import { LOADING_TYPES } from "../constants";
import { SkeletonDashboard } from "./skeletons/SkeletonPrimitives";

/**
 * Suspense fallback for lazy-loaded routes.
 * Starts global loading + shows skeleton layout (stable, no blank screen).
 */
export default function LazyRouteFallback() {
  const taskId = useRef(null);

  useEffect(() => {
    taskId.current = startLoading({
      type: LOADING_TYPES.NAVIGATION,
      message: "Loading page…",
    });
    return () => {
      if (taskId.current) stopLoading(taskId.current);
    };
  }, []);

  return (
    <div className="p-4 md:p-6">
      <SkeletonDashboard />
    </div>
  );
}
